<mat-form-field class="select-language">
  <mat-select [(ngModel)]="language" name="language" *ngIf="languages.length > 0" (selectionChange)="changeLang()">
    <mat-option [value]="lang" *ngFor="let lang of languages">{{ lang }}</mat-option>
  </mat-select>
</mat-form-field>
